import { COLOR, SIZE } from './constants';
import SimpleButton from './SimpleButton';

export { COLOR, SIZE };
export default SimpleButton;
